import { render, staticRenderFns } from "./moreList.vue?vue&type=template&id=29aa1350&scoped=true&"
import script from "./moreList.vue?vue&type=script&lang=ts&"
export * from "./moreList.vue?vue&type=script&lang=ts&"
import style0 from "./moreList.vue?vue&type=style&index=0&id=29aa1350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa1350",
  null
  
)

export default component.exports